var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-calc-mode"},[_c('criterion-input-radio',{attrs:{"name":_vm.selectMode.name,"variants":_vm.selectMode.values,"selectedValue":_vm.mode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }